module.exports = __webpack_public_path__ + "public/img/logo-horizontal.54730677.png";